import React from 'react';
import loading from '../assets/loading.svg';

export const Loading = () => (
  <div className="spinner">
    <img src={loading as unknown as string} alt="Loading" />
  </div>
);
